import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CoreRoutes } from './core.routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthedModule } from './authed/authed.module';
import { CommonModule } from '@angular/common';
import { NoAuthModule } from './no-auth/no-auth.module';

import { UrlService } from '@shared/services/url/url.service';
import { HttpService } from '@shared/services/http/http.service';
import { CdkColumnDef } from '@angular/cdk/table';
import { ToastrModule } from 'ngx-toastr';
import { EmailConfirmationComponent } from './account/components/email-confirmation/email-confirmation.component';
import { StockEntryMobileUploadComponent } from '../tvf/stock-entry/pages/mobile-upload/stock-entry-mobile-upload.component';

@NgModule({
  imports: [
    NoAuthModule,
    AuthedModule,
    CommonModule,
    CoreRoutes,
    BrowserAnimationsModule,
    SharedModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
  ],
  providers: [UrlService, HttpService, CdkColumnDef],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [EmailConfirmationComponent, StockEntryMobileUploadComponent],
})
export class CoreModule {}
